import React, { memo, forwardRef } from "react";
const SvgUnion = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M9 8a1 1 0 011 1v7a6 6 0 0012 0V9a1 1 0 112 0v7a8 8 0 11-16 0V9a1 1 0 011-1z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgUnion.displayName = "SvgUnion";
const MemoForwardRef = memo(SvgUnion);
export default MemoForwardRef;
